import React from "react";
import { Provider } from "react-redux";
// import { BrowserRouter } from "react-router-dom";
import RoutesComponent from "./Routes";
import useAuth from "./hooks/useAuth";
import { store } from "./app/store";
import { LanguageProvider } from "./hooks/LanguageContext";
import { ToastContainer } from "react-toastify"; // Import ToastContainer
import "react-toastify/dist/ReactToastify.css"; // Ensure styles are imported
import { MsalProvider } from "@azure/msal-react";
import { PublicClientApplication } from "@azure/msal-browser";

import { msalConfig } from "./config/msalConfig";
import { UnitProvider } from "./hooks/UnitProvider";

const App = () => {
  const { isAuthenticated, login, logout, loading } = useAuth();

  const msalInstance = new PublicClientApplication(msalConfig);

  return (
    <MsalProvider instance={msalInstance}>
      <LanguageProvider>
        <Provider store={store}>
          <UnitProvider>
            {/* <BrowserRouter> */}
            <ToastContainer />
            <RoutesComponent
              isAuthenticated={isAuthenticated}
              login={login}
              logout={logout}
              loading={loading}
            />
          </UnitProvider>
          {/* </BrowserRouter> */}
        </Provider>
      </LanguageProvider>
    </MsalProvider>
  );
};

export default App;
